/**
 * Determines which config are supported on the current environment.
 *
 * @param configs - An array of configurations to check.
 * @param isTypeSupported - A function that returns true if the config is supported.
 * @return `MediaKeySystemConfiguration` if there is a supported configuration,
 * `null` otherwise.
 */
export function getMediaKeySystemConfiguration(configs, isTypeSupported) {
    var _a, _b;
    for (let i = 0, l = configs.length; i < l; i++) {
        const config = configs[i];
        const capabilities = {
            audioCapabilities: [],
            videoCapabilities: [],
        };
        let x;
        let y;
        let cap;
        let contentType;
        let hasSupported = false;
        // Audio caps
        if ((_a = config.audioCapabilities) === null || _a === void 0 ? void 0 : _a.length) {
            hasSupported = false;
            for (x = 0, y = config.audioCapabilities.length; x < y; x++) {
                cap = config.audioCapabilities[x];
                contentType = cap.contentType;
                if (!contentType) {
                    continue;
                }
                if (isTypeSupported(contentType)) {
                    capabilities.audioCapabilities.push(cap);
                    hasSupported = true;
                }
            }
        }
        // Video caps
        if ((_b = config.videoCapabilities) === null || _b === void 0 ? void 0 : _b.length) {
            hasSupported = false;
            for (x = 0, y = config.videoCapabilities.length; x < y; x++) {
                cap = config.videoCapabilities[x];
                contentType = cap.contentType;
                if (!contentType) {
                    continue;
                }
                if (isTypeSupported(contentType)) {
                    capabilities.videoCapabilities.push(cap);
                    hasSupported = true;
                }
            }
        }
        if (hasSupported) {
            return capabilities;
        }
    }
    return null;
}
//# sourceMappingURL=eme.js.map